import { genVW } from '../utils/handlerUnit'

/**
 * 单位转换工具函数
 * @param value - 需要转换的值（字符串或数字）
 * @returns 转换后的 CSS 值
 */
export function addUnit(value: string | number): string {
  if (typeof value === 'number') {
    return genVW(value)
  }
  if (typeof value === 'string') {
    // 如果已经有单位，直接返回
    if (/px|em|rem|%|vw|vh|pt|cm|mm|in$/.test(value)) {
      return value
    }
    // 如果是数字（包括小数点），转换为数字并添加单位 支持负数
    if (/^-?\d+(\.\d+)?$/.test(value)) {
      return genVW(Number(value))
    }
    return value
  }
  return ''
}
